import { createAction } from '@ngrx/store';

export const requestAskResearch = createAction('[Common Ask Research] Request Ask Research');
